export const PRICE_SETTING_TOOL_DATA = "price_setting_tool_data";
